import mezhane from './images/1.png';
import mezhaneShowcase from './images/showcase_ml.jpg'
import BEZ from './images/2.png';
export const additionLuvers = [
  {
    "title": "MIESZANY OCZKA",
    "picture_choose":mezhane,
    "picture_showcase": mezhaneShowcase,
    "id": "mieszany_oczka"
  },
  {
    "title": "BEZ OCZEK",
    "picture_showcase": BEZ,
    "picture_choose": BEZ,
    "id": "BEZ_OCZEK"
  }
]

export const additionWindow = [
  {
  "title": "BEZ OKNA",
  "picture_choose":BEZ,
  "picture_showcase": BEZ,
  "id": "bez_okna"
  }
]
